import { Layout } from 'antd';
import { FC, ReactNode } from 'react';
import styled from 'styled-components';

import { AppBreadCrumbs } from './AppBreadcrumbs';
import { AppHeader } from './AppHeader';
import { SideMenu } from './SideMenu';

const { Content } = Layout;

export interface AppLayoutProps {
  children: ReactNode;
}

export const AppLayout: FC<AppLayoutProps> = ({ children }) => {
  return (
    <FullScreenLayout>
      <AppHeader />
      <LayoutContent>
        <SideMenu />
        <AppBreadCrumbs />
        <ContentWrapper>{children}</ContentWrapper>
      </LayoutContent>
    </FullScreenLayout>
  );
};

const FullScreenLayout = styled(Layout)`
  min-height: 100vh;
  background: #141414;
`;

const LayoutContent = styled(Content)`
  position: relative;
`;

const ContentWrapper = styled.div`
  padding: 24px 32px 0px 80px;
  margin-bottom: 10%;
`;
